import React, { useEffect, useState, useCallback } from 'react';
import styles from './NotificationToast.module.css';

/**
 * NotificationToast - In-app notification that shows when tab is focused
 * Mimics system notifications but appears within the app
 */
export default function NotificationToast({ notification, onClose, duration = 5000 }) {
  const [isVisible, setIsVisible] = useState(false);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Wait for fade-out animation
  }, [onClose]);

  useEffect(() => {
    if (notification) {
      // Trigger animation
      setIsVisible(true);

      // Auto-dismiss after duration
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [notification, duration, handleClose]);

  if (!notification) return null;

  return (
    <div
      className={`${styles.toastContainer} ${isVisible ? styles.visible : ''}`}
      onClick={handleClose}
    >
      <div className={styles.toast}>
        <div className={styles.icon}>
          <img
            src="/icon-192x192.png"
            alt="Sophia"
            className={styles.iconImage}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{notification.title}</div>
          <div className={styles.body}>{notification.body}</div>
        </div>
        <button
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}
